import { render } from "./AposInputArray.vue?vue&type=template&id=9cc8474c&scoped=true"
import script from "./AposInputArray.vue?vue&type=script&lang=js"
export * from "./AposInputArray.vue?vue&type=script&lang=js"

import "../scss/AposInputArray.scss?vue&type=style&index=0&id=9cc8474c&lang=scss&scoped=true&external"
import "./AposInputArray.vue?vue&type=style&index=1&id=9cc8474c&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc8474c"],['__file',"schema/ui/apos/components/AposInputArray.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cc8474c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cc8474c', __exports__)) {
    api.reload('9cc8474c', __exports__)
  }
  
  module.hot.accept("./AposInputArray.vue?vue&type=template&id=9cc8474c&scoped=true", () => {
    api.rerender('9cc8474c', render)
  })

}


export default __exports__